<template>
  <div id="tp3list">
    <app-gridview
      v-bind:parentData="{
        tabHeaders: this.dataHeader,
        tabItems: this.dataItems,
        pageTitle: this.pageTitle,
        search: this.search,
      }"
      v-on:EditItem="editItemHandler($event)"
      v-on:DeleteItem="deleteItemHandler($event)"
      v-on:NewPressed="newRecordHandler"
    ></app-gridview>
  </div>
</template>


<script>
import moment from "moment";

import GridView from "../../../components/common/GridView";

export default {
  components: {
    "app-gridview": GridView,
  },

  data() {
    return {
      pageTitle: this.$t('setuppersonpcbbfinformation.staffpcbbfinfotp3list'),
      dataHeader: [
        { text: this.$t('columns.actions'), value: "action", sortable: false, width: "80px" },
        { text: this.$t('columns.staffname'), value: "personname", width: "200px" },
        { text: this.$t('columns.startdate'), value: "startdate", width: "150px" },
        { text: this.$t('setuppersonpcbbfinformation.taxgross'), value: "taxgross", width: "150px" },
        { text: this.$t('setuppersonpcbbfinformation.epfpaid'), value: "epfpaid", width: "120px" },
        { text: this.$t('setuppersonpcbbfinformation.pcbpaid'), value: "pcbpaid", width: "120px" },
        { text: this.$t('setuppersonpcbbfinformation.rebate'), value: "rebate", width: "120px" },
        { text: this.$t('setuppersonpcbbfinformation.taxablerebate'), value: "loectax", width: "120px" },
        { text: this.$t('columns.remark'), value: "remark", width: "200px" },
      ],
      dataItems: [],
      loading: false,
      errMsg: "",
      search: this.$route.params.search,
    };
  },

  methods: {
    getTp3ListHandler() {
      const vm = this;

      this.loading = !this.loading;

      this.$store.dispatch('get', {
          // this.$store.getters.apiURL + '/tp3/all'
          url: `/tp3/all/${this.$store.getters.userId}`})
        .then(function (res) {
          vm.dataItems = res.data.rec;

          for (let i = 0; i < vm.dataItems.length; i++) {
            if (vm.dataItems[i].startdate) {
              vm.dataItems[i].startdate = moment(
                vm.dataItems[i].startdate
              ).format("YYYY-MM-DD");
            }
          }

          vm.loading = !vm.loading;
        })
        .catch(function (err) {
          vm.errMsg = err;
        });
    },

    editItemHandler(item) {
      this.$router.push({ name: "tp3edit", params: { id: item.id, search: item.search } });
    },

    newRecordHandler() {
      this.$router.push({ name: "tp3new" });
    },
  },

  mounted() {
    this.getTp3ListHandler();
  },
};
</script>